<template lang="pug">
.tabs.home
  .tabs-holder
    router-link(to="/referral" :class="{'aaa': currentPath==='/referral'}")
      img(src='assets/img/menu/m-refer.png')
      span {{$tc('ui.referral')}}
    router-link(to="/hot" :class="{'aaa': currentPath==='/hot'}")
      img(src='assets/img/menu/m-hot.png')
      span Hot
    router-link(to="/partners" :class="{'aaa': currentPath==='/partners'}")
      img(src='assets/img/menu/m-partner.png')
      span {{$t('ui.partner_short')}}
    router-link.epic(to='/' :class="{'aaa': currentPath==='/'}" @click.native="refreshSlot")
      img(src='assets/img/menu/m-epic.gif')
      span {{$t('ui.slotgames')}}
    router-link(to='/live' :class="{'aaa': currentPath==='/live'}")
      img(src='assets/img/menu/m-live.png')
      span {{$t('ui.live')}}
    router-link(to='/fish' :class="{'aaa': currentPath==='/fish'}")
      img(src='assets/img/menu/m-fish.png')
      span {{$t('ui.fish')}}
    router-link(to='/poker' :class="{'aaa': currentPath==='/poker'}")
      img(src='assets/img/menu/m-poker.png')
      span {{$t('ui.poker')}}
    router-link(to='/minigame' :class="{'aaa': currentPath==='/minigame'}")
      img(src='assets/img/menu/m-hash.png')
      span {{$t('ui.minigame')}}
    router-link(to='/freeplay' :class="{'aaa': currentPath==='/freeplay'}")
      img(src='assets/img/menu/m-freeplay.png')
      span {{$t('ui.demoplay')}}
    //- router-link(to='video' :class="{'aaa': currentPath==='/video'}")
      img(src='assets/img/menu/m-video.png')
      span {{$t('ui.videos')}}
    //- router-link(to='contactUs' :class="{'aaa': currentPath==='/contactUs'}")
      img(src='assets/img/menu/m-contact.png')
      span {{$tc('ui.contactus')}}
    router-link(to='/news' :class="{'aaa': currentPath==='/news'}")
      img(src='assets/img/menu/m-news.png')
      span {{$tc('ui.news')}}
    router-link(to='/reviews' :class="{'aaa': currentPath==='/reviews'}")
      //- img(src='assets/img/menu/m-review.png')
      img(src='assets/img/menu/leaderboard-purple.png')
      span {{$tc('ui.leaderboard')}}
</template>
<script>
import { EventBus } from '@/event-bus';
export default {
  data(){
    return{
      currentPath:""
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  watch:{
    $route (to, from){
      this.currentPath = to.path
    }
  },
  mounted(){
    this.currentPath = this.$router.currentRoute.path
  },
  methods:{
    openLogModal(){
      $("#modal-login").modal("show")
    },
    refreshSlot(event){
      EventBus.$emit('refresh');
    }
  }
}
</script>